module.exports = __webpack_public_path__ + "./assets/icons/twitter.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitterIcon.svg
// module id = 165
// module chunks = 0 1